var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { WorkTemplate } from "../models/WorkTemplate/WorkTemplate";
import { WorkTemplateGroup } from "../models/WorkTemplate/WorkTemplateGroup";
/**
 * テンプレートグループ内のワークテンプレートの選択状態を切り替える
 */
export function selectWorkTemplateGroups(_a) {
    var templateGroups = _a.templateGroups, templateIds = _a.templateIds, selected = _a.selected, _b = _a.condition, condition = _b === void 0 ? function () { return true; } : _b;
    return templateGroups.map(function (templateGroup) {
        return condition(templateGroup)
            ? new WorkTemplateGroup(__assign(__assign({}, templateGroup), { workTemplates: selectWorkTemplates({
                    templates: templateGroup.workTemplates,
                    templateIds: templateIds,
                    selected: selected,
                }) }))
            : templateGroup;
    });
}
/**
 * ワークテンプレートの選択状態を切り替える
 */
export function selectWorkTemplates(_a) {
    var templates = _a.templates, templateIds = _a.templateIds, selected = _a.selected;
    return templates.map(function (template) {
        return templateIds.includes(template.id) ? new WorkTemplate(__assign(__assign({}, template), { selected: selected })) : template;
    });
}
